<template>
  <div class="shop-item">
    <div class="bg-10px"></div>
    <div class="shop-con" >
      <div class="input-con">
        <van-checkbox
            v-if="!cartEditState"
            v-model="shopChecked"
            :icon-size="15"
            checked-color="#f74646"
            @change="checkShop(itemData.shopId)"
            @click="clickCheck"
        />
        <van-checkbox
            v-if="cartEditState"
            v-model="editShopSelected"
            :icon-size="15"
            checked-color="#f74646"
            @click="editCheckShop(itemData.shopId)"
        />
      </div>
      <div class="img-con" @click="goSgShopIndex">
        <img class="img" :src="itemData.mapShopInfo.shopAvatar + '?imageView2/0/w/80/h/80'" alt="">
      </div>
      <div class="shop-name" @click="goSgShopIndex">{{ itemData.mapShopInfo.shopName }}</div>
    </div>

    <shop-goods-item
        v-for="(data, i) in goodsList"
        :key="data.goodsId"
        :itemData2="data"
        :shopIndexKey="indexKey"
        :shopId="itemData.shopId"
        :shopEditClick="count"
        @changeEditSkuSelect="changeEditSkuSelect"
    ></shop-goods-item>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import shopGoodsItem from '../shopGoodsItem'
import { introduce } from '@/api/mall/mallShop'
export default {
  props: {
    itemData: {
      required: true,
    },
    indexKey:{
      required: true,
    },
    shopEditClickAll:{
      required: false,
    },
  },
  components: {
    shopGoodsItem,
  },
  data(){
    return {
      shopChecked: false,
      isShopClick: false,//是否发生点击事件
      editShopSelected: false,
      goodsList: [],
      count: 1
    }
  },
  computed:{
    ...mapGetters([
      'cartList',//购物车列表
      'cartEditState',//是否编辑状态
    ])
  },
  watch: {
    itemData: {
      handler(newData, oldData) {
        this.shopChecked = newData.shopSelected
        this.editShopSelected = newData.editShopSelected
        this.goodsList = Object.assign([], newData.shopItems)
      },
      deep:true,
      immediate: true
    },
    shopEditClickAll: {
      handler(newData, oldData) {
        this.count++
      },
      deep:true,
      immediate: true
    },
    cartEditState(val){
      console.log('cartEditState',  this.cartEditState)
      if(val){
        this.editShopSelected = false
      }
    }
  },
  created(){

  },
  methods: {
    clickCheck(){
      this.isShopClick = true
    },
    checkShop(shopId){
      if(this.isShopClick){
        let shopItems = this.cartList[this.indexKey].shopItems.map(goods=>{
          return {skuId: goods.productCode, skuIdSelected: this.shopChecked}
        });
        let arr = [{shopId: this.cartList[this.indexKey].shopId, shopSelected: this.shopChecked, shopItems}]
        this.$store.dispatch('sg/changeBuyCartSelect', arr)
        this.isShopClick = false
      }
    },

    editCheckShop(shopId){
      this.editShopSelected = !this.editShopSelected
      console.log(shopId)
      let arr = []
      this.cartList.forEach((item, i)=>{
        let shopItems = []
        if(item.shopId === shopId){
          item.shopItems.forEach((item2, i2)=>{
            item2.editSkuIdSelected = this.editShopSelected
            shopItems.push(Object.assign({}, item2))
          })
          item.editShopSelected = this.editShopSelected
        }
        arr.push(Object.assign({}, item))
      })
      this.$store.dispatch('sg/changeBuyCartEditSelect', arr)
      this.count++
    },

    changeEditSkuSelect(data){
      // console.log('data---', data)
      let arr = []
      this.cartList.forEach((item, i)=>{
        let count = 0
        let itemsLength = item.shopItems.length
        let shopItems = []
        item.shopItems.forEach((item2, i2)=>{
          if(item2.productCode===data.skuId){
            item2.editSkuIdSelected = data.editSkuIdSelected
          }else {

          }
          // console.log('item2.productCode===data.skuId', item2.productCode, data.skuId)
          // console.log('item2.editSkuIdSelected', item2.editSkuIdSelected)
          if(item2.editSkuIdSelected){
            count++
          }
          shopItems.push(item2)
        })
        item.editShopSelected = (count===item.shopItems.length)
        arr.push(item)
      })
      this.$store.dispatch('sg/changeBuyCartEditSelect', arr)
    },

    goSgShopIndex(){
      if(this.cartEditState){return false}
      this.$router.push({ name: 'sgShopIndex', query: {shopId: this.itemData.shopId} })
    },
  }
}
</script>

<style lang="less" scoped>
.shop-item{
  font-size: 14px;color: #2b2b2b;
  .shop-con{
    display: flex;height: 50px;
    .input-con{
      display: flex;justify-content: center;align-items: center;
      width: 39px;height: 100%;
    }
    .img-con{
      display: inline-flex;justify-content: center;align-items: center;height: 100%;
      .img{width: 24px;height: 24px;border-radius: 50%;}
    }
    .shop-name{
      min-width: 150px;height: 100%;padding-left: 12px;
      display: inline-flex;justify-content: flex-start;align-items: center;
    }
  }
}
</style>